var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = require("@/static/public/right.png")

  var m1 = require("@/static/public/right.png")

  var m2 = require("@/static/public/right.png")

  var m3 = require("@/static/public/right.png")

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        m2: m2,
        m3: m3
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }